import { v4 as uuid } from "uuid";

export const getTrackingEventId = (): string => uuid();
